<template>
  <div>
    <hero-alt
      img="https://image.freepik.com/vecteurs-libre/fond-technologie-numerique-fil-maille-reseau_1017-27428.jpg"
      title="Liste des références produits"
    />
    <table-view />
    <upload />
  </div>
</template>

<script>
export default {
  name: "Home",

  metaInfo: { title: "References" },

  data: () => ({}),

  methods: {},
  components: {
    HeroAlt: () => import("@/components/mixins/HeroAlt"),
    TableView: () => import("@/components/AllRefsTable"),
    upload: () => import("@/components/UploadRefList")
  }
};
</script>
